
const VideoExample = () => {
  return (
    <div className="min-w-screen min-h-screen flex justify-center items-center">
      <video src='https://cdn.jumpstar.app/solve/example/solveclip-example.mp4' controls style={{
        maxWidth: '900px'
      }} ></video>
    </div>
  );
};
export default VideoExample;
